import {Component} from 'react';
import h from 'react-hyperscript';
import {Redirect} from 'react-router';
import './ReportCardOverview.scss';
import Hero from 'Pages/ReportCardOverview/Hero/Hero';
import ArchiveGuest from 'Pages/ReportCardOverview/Archive/ArchiveGuest';
import content from 'Assets/data/report-card-overview.json';
import {ENDPOINTS, getAccessToken} from 'Src/utils/utils';
import heroImage from 'Assets/report-hero.svg';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

class GuestOverview extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      surveyStatus: {
        share_survey_url: '',
      },
      latestReport: null,
      isLoaded: false,
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userStatus !== this.props.userStatus) {
      this.setLatestSurveyComplete();
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.setLatestSurveyComplete();

    this.setState({
      reportLoading: true,
    });

    this.fetchDistrictsList();
  }

  fetchDistrictsList() {
    return fetch(ENDPOINTS.DISTRICT_LIST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        access_token: getAccessToken(this.props.googleUser),
      }),
    })
        .then((response) => {
          return response.json();
        })
        .then(
            (result) => {
              this.setState({
                districtNames: result,
                isLoaded: true,
              });
            },
            (error) => {
              console.log('No result', error);
            }
        );
  }

  setLatestReport(value) {
    this.setState({
      latestReport: value,
    });
  }

  setLatestSurveyComplete() {
    if (this._isMounted) {
      const value =
          !(this.props.userStatus.user_survey_state === 'Not Started' ||
              this.props.userStatus.user_survey_state === 'Partial');

      this.setState(
          {
            latestSurveyComplete: value,
          },
          () => {
            this.checkSurveyAndReportStatus();
          }
      );
    }
  }

  checkSurveyAndReportStatus() {
    const noReportAvailable = !this.state.newReportAvailable;
    const surveyIsClosed = !this.state.surveyOpenPeriod;
    const surveyNotComplete = !this.state.latestSurveyComplete;
    const reportIsAvailable =
      this.state.newReportAvailable &&
      surveyIsClosed &&
      this.state.latestSurveyComplete &&
      this.state.latestReport;
    const surveyIsAvailable =
      noReportAvailable && this.state.surveyOpenPeriod && surveyNotComplete;
    const surveyIsComplete =
      noReportAvailable && this.state.latestSurveyComplete;

    let activeComponent;

    if (reportIsAvailable) {
      activeComponent = 'ReportAvailableState';
    } else if (surveyIsAvailable) {
      activeComponent = 'SurveyAvailableState';
    } else if (surveyIsComplete) {
      activeComponent = 'SurveyCompleteState';
    } else {
      activeComponent = 'NoReportState';
    }

    this.setSurveyReportStatus(activeComponent);
  }

  setSurveyReportStatus(value) {
    this.setState({
      activeComponent: value,
    });
  }

  render() {
    if (this.props.userStatus &&
        this.props.userStatus.admin_level !== 'Guest') {
      return (
        h(Redirect, {to: '/app'})
      );
    }
    if (this.state.isLoaded) {
      return h(
          'div',
          {
            className: 'container',
          },
          [
            h(
                Hero,
                {
                  key: 'report-card-overview__hero',
                  image: heroImage,
                  content: content.hero.guest,
                },
                null
            ),

            h(
                ArchiveGuest,
                {
                  key: 'report-card-overview__archive',
                  activeComponent: this.state.activeComponent,
                  userStatus: this.props.userStatus,
                  googleUser: this.props.googleUser,
                  csrf: this.props.csrf,
                  idToken: this.props.idToken,
                  districtNames: this.state.districtNames,
                  setLatestReport: (value) => this.setLatestReport(value),
                  setLatestSurveyComplete: () => this.setLatestSurveyComplete(),
                },
                null
            ),

          ]
      );
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default GuestOverview;
